module.exports = __webpack_public_path__ + "img/8e70bc4.jpg";